export default "__VITE_ASSET__DWp0f$5U__"